// #region common
import API from '../config';

const base = `${API.BASE_DEV_HOST}/api/dashboard`;

export const getPublicCompsByDate = `${base}/public-companies`;
export const downloadValuationReport = (cmdId: number) => `${base}/download-valuation-report/${cmdId}`;
